import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CategoryService } from 'app/services/category/category.service';
import { CategoryDto } from 'app/models/category-response';
import { environment } from 'app/environments/environment';
import { max } from 'lodash';
import { ImageUrlPipe } from 'app/modules/admin/pipe/image-url.pipe';
import { GalleryPickerComponent } from 'app/shared/gallery-picker/gallery-picker.component';
import { ImageFallbackDirective } from 'app/modules/admin/directives/ImageFallbackDirective';
import { ImageItem } from 'app/services/gallery/gallery.service';

@Component({
  selector: 'app-edit-category',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ImageUrlPipe, GalleryPickerComponent, ImageFallbackDirective],
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.scss']
})
export class EditCategoryComponent implements OnInit {
  categoryForm: FormGroup;
  parentCategories: any[] = [];
  isLoading: boolean = false;
  isSubmitting: boolean = false;
  selectedFileName: string = '';
  imagePreview: string | null = null;
  selectedFile: File | null = null;
  currentCategory: any = null;
  categorySlug: string = '';
  categoryId: number = 0;
  isGalleryModalOpen = false;
  selectedPhotos: ImageItem[] = [];
  lang: string = ''
  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.categoryForm = this.createForm();
    this.lang = 'eg'
  }

  ngOnInit() {
    this.categorySlug = this.route.snapshot.paramMap.get('slug') || '';
    this.categoryId = Number(this.categorySlug.split('-')[0]);
    if (this.categorySlug) {
      this.loadCategoryData();
      this.loadParentCategories();
    } else {
      alert('Category slug not found');
      this.router.navigateByUrl('/admin/categories');
    }
  }

  createForm(): FormGroup {
    return this.fb.group({
      parentId: [0, [Validators.required, Validators.min(0)]],
      level: [0, [Validators.required, Validators.min(0)]],
      code: ['', [Validators.required, Validators.minLength(1)]],
      arName: ['', [Validators.required, Validators.minLength(2)]],
      enName: ['', [Validators.required, Validators.minLength(2)]],
      // commissionRate: [0, [Validators.min(0), Validators.max(100)]],
      // discount: [0, [Validators.min(0), Validators.max(100)]],
      // discountStartDate: [''],
      // discountEndDate: [''],
      icon: [null],
      featured: [false],
      top: [false],
      slug: [
        '',
        [
          Validators.required,
          Validators.pattern(/^[a-zA-Z0-9]+$/)
        ]
      ], status: [true]
    });
  }

  loadCategoryData() {
    this.isLoading = true;////////////////هتبقي ترو بس عشان لسه معملتش السرفيس

    this.categoryService.getCategoryById(this.categoryId).subscribe({
      next: (response) => {
        // response.icon = environment.photosUrl + response.icon
        this.currentCategory = response;

        this.populateForm(this.currentCategory);
        console.log(response);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error loading category data:', error);
        this.isLoading = false;
        alert('Failed to load category data');
        this.router.navigateByUrl('/admin/categories');
      }
    });
  }

  loadParentCategories() {
    this.categoryService.getSubCategories().subscribe({
      next: (response) => {
        // استبعاد التصنيف الحالي من قائمة الـ parent categories
        this.parentCategories = (response.data || []).filter(
          (category: any) => category.id !== this.currentCategory?.id
        );
      },
      error: (error) => {
        console.error('Error loading parent categories:', error);
        this.parentCategories = [];
      }
    });
  }

  populateForm(category: CategoryDto) {
    // تحويل التواريخ للتنسيق المناسب لـ datetime-local
    const formatDateForInput = (dateString: string) => {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toISOString().slice(0, 16);
    };

    this.categoryForm.patchValue({
      parentId: category.parent_id || 0,
      level: category.level || 0,
      code: category.code || '',
      arName: category.ar_name,
      enName: category.en_name || category.name || '',
      // commissionRate: category.commissionRate || 0,
      // discount: category.discount || 0,
      // discountStartDate: formatDateForInput(category.discountStartDate),
      // discountEndDate: formatDateForInput(category.discountEndDate),
      featured: category.featured || false,
      top: category.top || false,
      slug: category.slug || '',
      status: category.status !== undefined ? category.status : true
    });
    console.log(this.categoryForm);
    // تحميل الصورة الحالية إذا كانت موجودة
    console.log(category.icon);
    if (category.icon) {
      this.imagePreview = category.icon;
      this.selectedFileName = 'Current icon';
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ['image/jpeg', 'image/png', 'image/svg+xml', 'image/webp'];
      if (!validTypes.includes(file.type)) {
        alert('Please select a valid image file (JPG, PNG, SVG, WebP)');
        return;
      }

      // Validate file size (2MB max)
      if (file.size > 2 * 1024 * 1024) {
        alert('File size must be less than 2MB');
        return;
      }

      this.selectedFile = file;
      this.selectedFileName = file.name;
      this.categoryForm.patchValue({ icon: file });

      // Create preview
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage() {
    this.selectedFile = null;
    this.selectedFileName = '';
    this.imagePreview = null;
    this.categoryForm.patchValue({ icon: '' });
  }

  validateDiscountDates(): boolean {
    const startDate = this.categoryForm.get('discountStartDate')?.value;
    const endDate = this.categoryForm.get('discountEndDate')?.value;

    if (startDate && endDate) {
      const start = new Date(startDate);
      const end = new Date(endDate);

      if (end <= start) {
        alert('Discount end date must be after start date');
        return false;
      }
    }
    return true;
  }

  generateSlug() {
    const enName = this.categoryForm.get('enName')?.value;
    if (enName) {
      const slug = enName
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');

      this.categoryForm.patchValue({ slug });
    }
  }

  async onSubmit() {
    if (this.categoryForm.invalid) {
      this.markAllFieldsAsTouched();
      return;
    }

    if (!this.validateDiscountDates()) {
      return;
    }

    this.isSubmitting = true;

    try {
      const formData = this.categoryForm.value;
      console.log(formData);
      this.categoryService.editCategory(this.currentCategory.slug, formData).subscribe({
        next: (response) => {
          this.isSubmitting = false;
          alert('✅ Category updated successfully!');
          this.router.navigateByUrl('/admin/categories');
        },
        error: (error) => {
          this.isSubmitting = false;
          console.error('❌ Error updating category:', error);
          alert('⚠️ Failed to update category. Please try again.');
        }
      });
    } catch (error) {
      this.isSubmitting = false;
      console.error('❌ Error preparing form data:', error);
      alert('⚠️ Error preparing form data. Please check your inputs.');
    }
  }

  prepareFormData(): FormData {
    const formValue = this.categoryForm.value;
    console.log("value:", formValue);
    const formData = new FormData();

    // Append all form fields
    Object.keys(formValue).forEach(key => {
      if (key !== 'icon') {
        formData.append(key, formValue[key]);
      }
    });

    // Append file if selected
    if (this.selectedFile) {
      formData.append('icon', this.selectedFile);
    } else if (!this.imagePreview && formValue.icon === '') {
      // إذا تم حذف الصورة
      formData.append('removeIcon', 'true');
    }

    return formData;
  }

  markAllFieldsAsTouched() {
    Object.keys(this.categoryForm.controls).forEach(key => {
      this.categoryForm.get(key)?.markAsTouched();
    });
  }

  showError(controlName: string): boolean {
    const control = this.categoryForm.get(controlName);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  getError(controlName: string): string {
    const control = this.categoryForm.get(controlName);
    if (control?.errors) {
      if (control.errors['required']) return 'This field is required';
      if (control.errors['minlength']) return `Minimum length is ${control.errors['minlength'].requiredLength}`;
      if (control.errors['min']) return `Minimum value is ${control.errors['min'].min}`;
      if (control.errors['max']) return `Maximum value is ${control.errors['max'].max}`;
    }
    return 'Invalid value';
  }

  getCategoryName(category: any): string {
    return category?.name || category?.enName || category?.arName || 'Unnamed Category';
  }

  goBack() {
    this.router.navigateByUrl('/admin/categories');
  }

  // دالة للتحقق إذا كانت هناك تغييرات في الفورم
  hasChanges(): boolean {
    if (!this.currentCategory) return false;

    const formValue = this.categoryForm.value;
    return (
      formValue.parentId !== this.currentCategory.parentId ||
      formValue.level !== this.currentCategory.level ||
      formValue.code !== this.currentCategory.code ||
      formValue.arName !== (this.currentCategory.arName || this.currentCategory.name) ||
      formValue.enName !== (this.currentCategory.enName || this.currentCategory.name) ||
      formValue.commissionRate !== this.currentCategory.commissionRate ||
      formValue.discount !== this.currentCategory.discount ||
      formValue.discountStartDate !== this.formatDateForInput(this.currentCategory.discountStartDate) ||
      formValue.discountEndDate !== this.formatDateForInput(this.currentCategory.discountEndDate) ||
      formValue.featured !== this.currentCategory.featured ||
      formValue.top !== this.currentCategory.top ||
      formValue.slug !== this.currentCategory.slug ||
      formValue.status !== this.currentCategory.status ||
      this.selectedFile !== null
    );
  }

  private formatDateForInput(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toISOString().slice(0, 16);
  }


  openGalleryModal(): void {
    this.isGalleryModalOpen = true;
  }

  closeGalleryModal(): void {
    this.isGalleryModalOpen = false;
  }

  onGalleryImagesChange(images: ImageItem[]): void {
    this.selectedPhotos = images || [];

    const firstImage = this.selectedPhotos[0];

    if (!firstImage) return;

    this.selectedFile = null;
    this.selectedFileName = firstImage.name || 'Gallery icon';
    this.imagePreview = firstImage.url;

    this.categoryForm.patchValue({
      icon: Number(firstImage.id)
    });

    this.closeGalleryModal();
  }
}